var advance = function() {
  document.querySelectorAll('.grid-meta-color li').forEach((color) => {
    color.addEventListener('mouseover',function(){
      if(color.querySelector('img') != null && color.closest('.snippet-product-grid') != null){
        color.closest('.snippet-product-grid').querySelector('.product-images img').setAttribute('srcset',color.querySelector('img').getAttribute('src'))
      }
    })
    color.addEventListener('mouseout',function(){
      if(color.querySelector('img') != null && color.closest('.snippet-product-grid') != null){
        color.closest('.snippet-product-grid').querySelector('.product-images img').setAttribute('srcset',color.closest('.grid-meta-color').querySelector('li a.active img').getAttribute('src'))
      }
    })
  });
  $th_refreshWishlistItems();
  attachProductClickEvents();
  if (window.innerWidth <= 991) {
    if (typeof initProductGridProgressBars === 'function') initProductGridProgressBars();
  }
}
var infinitescroll = {
  instance: null,
  scolljs: function(){
    var productGrid = document.querySelector('#product-grid');
    var pagination = document.querySelector('#AjaxinatePagination');
    
    if (!productGrid || !pagination) {
      return;
    }
    
    if (this.instance && typeof this.instance.destroy === 'function') {
      this.instance.destroy();
    }
    
    this.instance = new Ajaxinate({
      container: '#product-grid',
      pagination: '#AjaxinatePagination',
      callback: advance,
      offset:1000
    });
  }
}

infinitescroll.scolljs();

window.addEventListener('pageshow', function(event) {
  if (event.persisted) {
    infinitescroll.scolljs();
  }
});

function attachProductClickEvents() {
  const productLinks = document.querySelectorAll('.product-item a');
  productLinks.forEach(link => {
    // remove existing named handler (works because handleProductClick is a named fn)
    link.removeEventListener('click', handleProductClick);
    link.addEventListener('click', handleProductClick);
  });
}

function handleProductClick() {
  const collectionHandle = document.body.getAttribute('data-collection-handle') || window.location.pathname;
  const productGrid = document.querySelector('#product-grid');
  const paginationEl = document.querySelector('#AjaxinatePagination');

  sessionStorage.setItem(`${collectionHandle}-scrollPos`, window.scrollY);
  sessionStorage.setItem(`${collectionHandle}-gridHTML`, productGrid.innerHTML);
  // Save pagination state so Ajaxinate resumes from the correct next page
  sessionStorage.setItem(`${collectionHandle}-paginationHTML`, paginationEl ? paginationEl.innerHTML : '');
}

attachProductClickEvents();

if (window.performance && window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD) {
  const productGrid = document.querySelector('#product-grid');
  const paginationEl = document.querySelector('#AjaxinatePagination');
  const collectionHandle = document.body.getAttribute('data-collection-handle') || window.location.pathname;
  const savedScrollPos = sessionStorage.getItem(`${collectionHandle}-scrollPos`);
  const savedGridHTML = sessionStorage.getItem(`${collectionHandle}-gridHTML`);
  const savedPaginationHTML = sessionStorage.getItem(`${collectionHandle}-paginationHTML`);

  if (savedGridHTML && savedScrollPos) {
    // Destroy Ajaxinate BEFORE touching the DOM so it cannot fire a load
    // in response to the scroll we're about to trigger.
    if (infinitescroll.instance && typeof infinitescroll.instance.destroy === 'function') {
      infinitescroll.instance.destroy();
      infinitescroll.instance = null;
    }

    // Restore the full grid as the user left it
    productGrid.innerHTML = savedGridHTML;

    // The saved HTML already has data-progress-init="1" stamped on every
    // scroll container from when they were first initialised. Clear those
    // flags so initProductGridProgressBars() re-attaches listeners.
    if (window.innerWidth <= 991) {
      productGrid.querySelectorAll('[data-progress-init]').forEach(el => el.removeAttribute('data-progress-init'));
      if (typeof initProductGridProgressBars === 'function') initProductGridProgressBars(productGrid);
    }

    // Restore pagination to the exact page the user was on so Ajaxinate
    // will load the correct *next* page (not re-load an already-shown page)
    if (paginationEl) {
      if (savedPaginationHTML) {
        paginationEl.innerHTML = savedPaginationHTML;
      } else {
        // No next page existed — hide pagination entirely
        paginationEl.style.display = 'none';
      }
    }

    window.scrollTo(0, savedScrollPos);

    // Re-init Ajaxinate now that grid + pagination are in their correct state
    infinitescroll.scolljs();

    // Re-attach colour-swatch hover + wishlist handlers for restored items
    if (typeof advance === 'function') try { advance(); } catch(e) {}

    // Cleanup
    sessionStorage.removeItem(`${collectionHandle}-scrollPos`);
    sessionStorage.removeItem(`${collectionHandle}-gridHTML`);
    sessionStorage.removeItem(`${collectionHandle}-paginationHTML`);
  }
};


let filter = document.querySelector("facet-filters-form").offsetTop;
var lastscroll = 0;
window.addEventListener("scroll", () => {
  let scrollcount = window.pageYOffset;
  (scrollcount >= filter) ? document.querySelector('body').classList.add("filter-sticky") : document.querySelector('body').classList.remove("filter-sticky")
  setTimeout(function(){
    if(scrollcount > lastscroll){
      document.querySelector('.snippet-collection-filter').style.top = '0px'
    }else if(scrollcount < lastscroll){
      if(window.innerWidth < 992){
      document.querySelector('.snippet-collection-filter').style.top = document.querySelector('.header-group').clientHeight - 35 +'px'
      }else{
        document.querySelector('.snippet-collection-filter').style.top = document.querySelector('.header-group').clientHeight - 40 +'px' 
      }
      // console.log(scrollcount,'---',window.pageYOffset,'---',window.outerHeight)
      // document.querySelector('.snippet-collection-filter').style.top = document.querySelector('.snippet-collection-filter').style.top + 8+'px'
      // if(scrollcount >= document.querySelector('.header-main').clientHeight){
      //   document.querySelector('.snippet-collection-filter').style.top = scrollcount + 'px'
      // }
    }
    lastscroll = scrollcount;
  }, 100);
});